import React from 'react';

// Ícone de 36x36 exportado do Figma (já inclui o círculo tracejado).
const Icone = ({ src }) => (
  <span className="icone">
    <img src={src} alt="" />
  </span>
);

export default Icone;
